export default __webpack_public_path__ + "static/media/secive_cliente.e224885c.jpeg";